__webpack_require__.f.compat = (chunkId, promises) => {

	const originalLoadChunk = __webpack_require__.l;
	__webpack_require__.l = flarum.reg.loadChunk.bind(flarum.reg, originalLoadChunk);
};